interface INewRelicMonitoringService {
  /*
    addCustomAttribute: function which is responsable for logging general custom data from the user to New Relic
  */
  addCustomAttribute: (name: string, value: string | number, persist?: boolean) => void;
  /*
    addPageAction: function which is responsable for logging actions on the page to New Relic
  */
  addPageAction: (name: string, data?: Record<string, any>) => void;
  /*
    addError: function which is responsable for logging error to New Relic
  */
  addError: (error: Error, data?: Record<string, any>) => void;
  setUserId: (value: string | null) => void;
}

interface NewRelicInterface {
  setCustomAttribute: (name: string, value: string | number, persist?: boolean) => void;
  addPageAction: (name: string, data?: Record<string, any>) => void;
  addError: (error: Error, data?: Record<string, any>) => void;
  noticeError: (error: Error, data?: Record<string, any>) => void;
  setUserId: (value: string | null) => void;
}

class NewRelicMonitoringService implements INewRelicMonitoringService {
  private readonly provider: NewRelicInterface;
  static instance: NewRelicMonitoringService;

  constructor() {
    this.provider = window.NREUM;
    if (!NewRelicMonitoringService.instance) {
      NewRelicMonitoringService.instance = this;
    }

    return NewRelicMonitoringService.instance;
  }

  addCustomAttribute(name: string, value: string | number, persist = false) {
    if (!this.provider?.setCustomAttribute) {
      return;
    }
    this.provider.setCustomAttribute(name, value, persist);
  }

  addPageAction(name: string, data?: Record<string, any>) {
    if (!this.provider?.addPageAction) {
      return;
    }
    if (!data) {
      this.provider.addPageAction(name);
    } else {
      this.provider.addPageAction(name, data);
    }
  }

  addError(error: Error, data?: Record<string, any>) {
    if (!this.provider?.noticeError) {
      return;
    }
    if (!data) {
      this.provider.noticeError(error);
    } else {
      this.provider.noticeError(error, data);
    }
  }

  setUserId(value: string | null) {
    if (!this.provider?.setUserId) {
      return;
    }
    if (!value) {
      return;
    }
    this.provider.setUserId(value);
  }
}

const newRelicMonitoringService = new NewRelicMonitoringService();

export default newRelicMonitoringService;
